export default {
  data() {
    return {
      showRequestSuccessfulMessage: false,
      showRequestSuccessfulMessageDuration: 2000
    }
  },
  methods: {
    async sendEventNote() {
      const input = this.$refs['ref-item-note']

      if (!input) {
        return
      }

      await this.$store.dispatch('saveEventCustomReply', {
        eventID: this.item.id,
        customAnswer: input.value
      })

      this.showRequestSuccessfulMessage = true
      window.setTimeout(() => this.showRequestSuccessfulMessage = false, this.showRequestSuccessfulMessageDuration)
    },
    async setParticipation(choice) {
      await this.$store.dispatch('saveEventParticipation', {
        eventID: this.item.id,
        choice: choice
      })
    }
  }
}
